module.exports = __webpack_public_path__ + "img/cxz.c35a2e91.png";